import {
    apiRequest,
    exportExcel,
} from "../../../../../services/adapters/kepegawaian/pensiunpegawaiService"

class IndexRepository {

    fetchExportExcel = async (query) => {
        return await apiRequest("get", exportExcel, {
            params: query
        }, true)
    }

  
}

export default IndexRepository